import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

export interface ChargeToMyRoomResult {
  name: string;
  roomNumber: string;
}

@Component({
  selector: 'app-charge-to-my-room',
  templateUrl: './charge-to-my-room.component.html',
  styleUrl: './charge-to-my-room.component.scss',
  standalone: false,
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline', floatLabel: 'auto', subscriptSizing: 'dynamic' } },
  ],
})
export class ChargeToMyRoomComponent implements OnInit {
  readonly sheetRef = inject(MatBottomSheetRef<ChargeToMyRoomComponent, ChargeToMyRoomResult>);

  formGroup: FormGroup;
  submitted = false;

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.minLength(2)]),
      roomNumber: new FormControl('', [Validators.required, Validators.minLength(2)]),
    });
  }

  confirm(): void {
    this.submitted = true;
    if (this.formGroup.invalid) return;

    this.sheetRef.dismiss({
      name: this.formGroup.value.name,
      roomNumber: this.formGroup.value.roomNumber,
    });
  }

  close(): void {
    this.sheetRef.dismiss();
  }
}
